import React, { Component } from 'react'
import StarRatings from 'react-star-ratings';
import CheckBoxes from '../partner/checkboxes'
import TextIput from '../../textInput'
import validation, { notEmpty, emailAddres, isValid } from '../../validations'
import { post } from '../../utils/networking'
import * as Notify from '../../notification'
import $ from 'jquery'
import './style.css'
var validationData = {
    title: [notEmpty],
    name: [notEmpty],
    description: [notEmpty]
}

export default class ReviewRating extends Component {
    constructor(props) {
        super(props)
        this.state = {
            overallRating: 1,
            serviceQuality: 1,
            serviceVariety: 1,
            spaFacilites: 1,
            fitnessFacilites: 1,
            visitAgain: [1],
            title: "",
            name: "",
            description: ""
        }

    }
    onOverallRatingChangeRating(newRating) {
        this.setState({
            overallRating: newRating
        });
    }
    onServiceQualityChangeRating(newRating) {
        this.setState({
            serviceQuality: newRating
        });
    }
    onServiceVarietyChangeRating(newRating) {
        this.setState({
            serviceVariety: newRating
        });
    }
    onSpaFacilitesChangeRating(newRating) {
        this.setState({
            spaFacilites: newRating
        });
    }
    onFitnessFacilitesChangeRating(newRating) {
        this.setState({
            fitnessFacilites: newRating
        });
    }
    onSelectVisitAgain() {
        this.setState({
            visitAgain: [1]
        })
    }
    onRemoveVisitAgain() {
        this.setState({
            visitAgain: [0]
        })
    }
    onSescriptionChange(e) {
        document.getElementById("description_validation").textContent = "";
        this.setState({
            description: e.target.value
        })
    }
    handleSubmit() {
        Notify.hide();
        let param = {
            overallRating: this.state.overallRating,
            serviceQuality: this.state.serviceQuality,
            serviceVariety: this.state.serviceVariety,
            spaFacilites: this.state.spaFacilites,
            fitnessFacilites: this.state.fitnessFacilites,
            visitAgain: (this.state.visitAgain[0] == true) ? false : true,
            title: this.state.title,
            description: this.state.description,
            spaId: this.props.spaID,
            reviewerName: this.state.name
        };
        if (this.state.description === "") {
            $("#description_validation").text("Response Text* must not empty.");
        }
        if (isValid(validationData) && this.state.description != "") {
            post("review/create", param, "", result => {
                Notify.show($("#review_submit"), "Write review success.", "success", "0");
            }, errors => {
                if (errors && errors.errors && errors.errors.length > 0)
                    Notify.show($("#review_submit"), errors.errors[0], "fail", "0");
            })
        }
    }

    handleCancel() {
        this.setState({
            overallRating: 1,
            serviceQuality: 1,
            serviceVariety: 1,
            spaFacilites: 1,
            fitnessFacilites: 1,
            visitAgain: [1],
            title: "",
            name: "",
            description: ""
        });
        $("#review-box").fadeOut();
        Notify.hide();
    }

    render() {
        let {
            overallRating,
            serviceQuality,
            serviceVariety,
            spaFacilites,
            fitnessFacilites,
            visitAgain,
            name,
            title,
            description
        } = this.state;
        return (
            <div id="review-box" className={(this.props.isPopup) ? "popup_box" : "default_box"} style={{ display: "none" }}>
                <div className="box_contain">
                    <div className="rating_header">
                        <span>Rate this Business</span>
                        <i className="fa fa-times" aria-hidden="true" onClick={this.handleCancel.bind(this)}></i>
                    </div>
                    <div className="rating_detail">
                        <div className="overall_rating rating">
                            <div className="rating_title">
                                <span>Overall Rating *</span>
                            </div>
                            <StarRatings
                                rating={overallRating}
                                isSelectable={true}
                                isAggregateRating={false}
                                changeRating={(value) => this.onOverallRatingChangeRating(value)}
                                numOfStars={5}
                                starEmptyColor="#ffffff"
                                starRatedColor="#935ED6"
                                starSelectingHoverColor="#935ED6"
                                starWidthAndHeight="25px"
                                starSpacing="1px"
                            />
                        </div>
                        <div className="service_quality rating">
                            <div className="rating_title">
                                <span>Service Quality</span>
                            </div>
                            <StarRatings
                                rating={serviceQuality}
                                isSelectable={true}
                                isAggregateRating={false}
                                changeRating={(value) => this.onServiceQualityChangeRating(value)}
                                numOfStars={5}
                                starEmptyColor="#ffffff"
                                starRatedColor="#935ED6"
                                starSelectingHoverColor="#935ED6"
                                starWidthAndHeight="25px"
                                starSpacing="1px"
                            />
                        </div>
                        <div className="service_variety rating">
                            <div className="rating_title">
                                <span>Service Variety</span>
                            </div>
                            <StarRatings
                                rating={serviceVariety}
                                isSelectable={true}
                                isAggregateRating={false}
                                changeRating={(value) => this.onServiceVarietyChangeRating(value)}
                                numOfStars={5}
                                starEmptyColor="#ffffff"
                                starRatedColor="#935ED6"
                                starSelectingHoverColor="#935ED6"
                                starWidthAndHeight="25px"
                                starSpacing="1px"
                            />
                        </div>
                        <div className="spa_facilites rating">
                            <div className="rating_title">
                                <span>Spa Facilites</span>
                            </div>
                            <StarRatings
                                rating={spaFacilites}
                                isSelectable={true}
                                isAggregateRating={false}
                                changeRating={(value) => this.onSpaFacilitesChangeRating(value)}
                                numOfStars={5}
                                starEmptyColor="#ffffff"
                                starRatedColor="#935ED6"
                                starSelectingHoverColor="#935ED6"
                                starWidthAndHeight="25px"
                                starSpacing="1px"
                            />
                        </div>
                        <div className="fitness_facilites rating">
                            <div className="rating_title">
                                <span>Fitness Facilites</span>
                            </div>
                            <StarRatings
                                rating={fitnessFacilites}
                                isSelectable={true}
                                isAggregateRating={false}
                                changeRating={(value) => this.onFitnessFacilitesChangeRating(value)}
                                numOfStars={5}
                                starEmptyColor="#ffffff"
                                starRatedColor="#935ED6"
                                starSelectingHoverColor="#935ED6"
                                starWidthAndHeight="25px"
                                starSpacing="1px"
                            />
                        </div>
                        <div className="visit_again">
                            <CheckBoxes
                                className="visit_again_checkboxes"
                                options={[{ id: 1, name: "I would visit this business again." }]}
                                selectOptions={visitAgain}
                                onSelect={this.onSelectVisitAgain.bind(this)}
                                onRemove={this.onRemoveVisitAgain.bind(this)}
                            />
                        </div>
                        <span className="your_review">Enter Your Review</span>
                        <div className="review_name">
                            <TextIput
                                name="name"
                                label="Your name? *"
                                showLabel={true}
                                showPlaceholder={false}
                                value={name}
                                validations={validationData.name}
                                onChange={(value) => this.setState({
                                    name: value
                                })}
                            />
                        </div>
                        <div className="review_title">
                            <TextIput
                                name="title"
                                label="Review Title *"
                                showLabel={true}
                                showPlaceholder={false}
                                value={title}
                                validations={validationData.title}
                                onChange={(value) => this.setState({
                                    title: value
                                })}
                            />
                        </div>
                        <div className="review_description">
                            <label>Response Text*</label>
                            <textarea value={description} className="description" id="description" onChange={(value) => this.onSescriptionChange(value)}></textarea>
                            <p id="description_validation" className="text-danger"></p>
                        </div>
                    </div>
                    <div className="rating_footer">
                        <button id="review_submit" onClick={this.handleSubmit.bind(this)}>Review</button>
                        <button id="review_cancel" onClick={this.handleCancel.bind(this)}>Cancel</button>
                    </div>
                </div>
            </div>

        )

    }
}


// WEBPACK FOOTER //
// ./src/components/review/index.js